import React from 'react';
import { FormContainer } from '../../common/form/FormContainer';
import FormItem from '../../common/form/FormItem';
import FormWidget from '../../common/form/FormWidget';
import { TermsetField } from '../attributes';

type TermsetValueEditorProps = {
    field: TermsetField;
};

export default (props: TermsetValueEditorProps) => {
    const { field } = props;
    const metadataName = field?.termset?.replace(/\s/g, '') || undefined;

    const staticOptions = !metadataName
        ? (field?.newTermset?.map((term) => (typeof term === 'string' ? term : (term as { label: string }).label)) ??
          [])
        : undefined;

    return (
        <FormContainer>
            <FormItem>
                <FormWidget
                    name={field.name}
                    component="MetadataAutocomplete"
                    metadataName={metadataName}
                    label={field.label}
                    allowCreate={field.allowCreate}
                    identifier="termset"
                    multiple={field.isMultiSelect}
                    optionValues={staticOptions}
                    hideHelperText
                />
            </FormItem>
        </FormContainer>
    );
};
